import {
  Grid,
  GridItem,
  SelectFormikField,
  SelectItem,
  Text,
  TextAreaFormikField,
} from "@certn/cascadia-react";
import { getPrivacyPolicyUrl } from "@certn/utils";
import { Field } from "formik";
import { useTranslation } from "react-i18next";

import { FormModal } from "./FormModal";
import { HelpPrivacyConsent } from "./HelpPrivacyConsent";
import { useTopicList } from "./utils";

interface GeneralFeedbackModalContentsProps {
  handleSubmit: () => void;
  close: () => void;
}

export function GeneralFeedbackModalContents(
  props: GeneralFeedbackModalContentsProps
) {
  const { handleSubmit, close } = props;
  const topicList = useTopicList();

  const { t, i18n } = useTranslation();
  const privacyPolicyUrl = getPrivacyPolicyUrl(i18n.language);

  return (
    <FormModal
      title={t("General feedback")}
      onSubmit={handleSubmit}
      onCancel={close}
      variant="success"
      continueText={t("Submit")}
    >
      <Grid form>
        <GridItem>
          <Text style="global/body-primary">
            {t(
              "We want to hear the good, the bad, and any ideas for improving the experience."
            )}
          </Text>
        </GridItem>
        <GridItem>
          <SelectFormikField
            name="topic"
            label={t("Topic")}
            placeholder={t("Please select")}
            isRequired
            testID="general-feedback-modal-topic-select"
          >
            {topicList.map((option) => (
              <SelectItem key={option.value} id={option.value}>
                {option.name}
              </SelectItem>
            ))}
          </SelectFormikField>
        </GridItem>
        <GridItem>
          <Field
            name="message"
            label={t("Message")}
            as={TextAreaFormikField}
            isRequired
            testID="general-feedback-modal-message-input"
          />
        </GridItem>
        <GridItem>
          <HelpPrivacyConsent privacyPolicyUrl={privacyPolicyUrl} />
        </GridItem>
      </Grid>
    </FormModal>
  );
}
